import { MCP_DEFAULT_SERVER_NAME } from '@/core/const/mcpGateway.const'
import { buildMcpClientConfig, buildMcpUrl } from '@/core/hooks/useInstallationConfig/mappers/buildMcpClientConfig'

export interface BuildGatewayMcpSnapshotParams {
  gatewayPath: string
  gatewayMcpPort?: string
  isSecured: boolean
  projectName?: string
}

export interface GatewayMcpSnapshot {
  mcpUrl: string
  serverName: string
  clientConfig: string
}

export function buildGatewayMcpSnapshot({
  gatewayPath,
  gatewayMcpPort,
  isSecured,
  projectName,
}: BuildGatewayMcpSnapshotParams): GatewayMcpSnapshot {
  const mcpUrl = buildMcpUrl(gatewayPath, gatewayMcpPort, isSecured)
  const serverName = projectName?.trim() || MCP_DEFAULT_SERVER_NAME
  const clientConfig = buildMcpClientConfig({ gatewayPath, gatewayMcpPort, isSecured, projectName })

  return {
    mcpUrl,
    serverName,
    clientConfig,
  }
}
